/**
 * @preserve
 * Licenses of bundled dependencies can be found in dependencies-licenses.txt
 */
function getPrecision(r){var e=String(r).match(/\.([0-9]*[1-9])/);return e&&e.length>0?e[1].length:0}export{getPrecision as g};
//# sourceMappingURL=get-precision-3f2278b3.js.map